// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"af59ce05","498":"56720606","513":"207fc8f5"}[chunkId] + ".chunk.js";
};